// extracted by mini-css-extract-plugin
export default {"inputholder":"Feedback_inputholder__ur6c9","inputbox":"Feedback_inputbox__A0pub","save":"Feedback_save__uMIef","cancel":"Feedback_cancel__X0MG3"};